/**
 * Quick reply chips for Orion Console (parity with ERP).
 * Renders quickReplies from API; click sends payload.prompt and optional quickReplyId.
 */
import React, { useCallback } from 'react';
import './OrionQuickReplies.css';

function getLabel(item, isRtl) {
  if (isRtl && item.labelAr) return item.labelAr;
  return item.label ?? item.id ?? '';
}

function getPayload(item) {
  const p = item.payload;
  if (p && typeof p === 'object' && Object.keys(p).length > 0) return p;
  return {};
}

export default function OrionQuickReplies({
  quickReplies = [],
  isRtl = false,
  onQuickReply,
  disabled = false,
  className = '',
  loadingQuickReplyId,
}) {
  const handleClick = useCallback(
    (e, item) => {
      e.preventDefault();
      if (disabled) return;
      const payload = getPayload(item);
      const prompt = payload?.prompt ?? payload?.text ?? getLabel(item, isRtl);
      onQuickReply?.({ prompt, quickReplyId: item.id, ...payload });
    },
    [disabled, onQuickReply, isRtl]
  );

  const handleKeyDown = useCallback(
    (e, item) => {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        if (disabled) return;
        const payload = getPayload(item);
        const prompt = payload?.prompt ?? payload?.text ?? getLabel(item, isRtl);
        onQuickReply?.({ prompt, quickReplyId: item.id, ...payload });
      }
    },
    [disabled, onQuickReply, isRtl]
  );

  if (!Array.isArray(quickReplies) || quickReplies.length === 0) return null;

  return (
    <div
      className={`orion-quick-replies ${className}`.trim()}
      role="group"
      aria-label={isRtl ? 'ردود سريعة' : 'Quick replies'}
      dir={isRtl ? 'rtl' : 'ltr'}
    >
      <div className="orion-quick-replies__list" role="list">
        {quickReplies.map((item, idx) => {
          const loading = loadingQuickReplyId === item.id;
          return (
            <button
              key={item.id ?? idx}
              type="button"
              role="listitem"
              className={`orion-quick-reply-chip${loading ? ' orion-quick-reply-chip--loading' : ''}`}
              onClick={(e) => handleClick(e, item)}
              onKeyDown={(e) => handleKeyDown(e, item)}
              disabled={disabled || loading}
              aria-label={getLabel(item, isRtl)}
              title={getLabel(item, isRtl)}
              tabIndex={disabled || loading ? -1 : 0}
            >
              {getLabel(item, isRtl)}
            </button>
          );
        })}
      </div>
    </div>
  );
}
